export enum CHAR_BOARD_THEME {
    DEFAULT = 'default',
    BOLD = 'bold',
}
